export const TUYA_ENERGY_CORRECTION_FACTOR = 0.93;

export function correctKwh(value, factor = TUYA_ENERGY_CORRECTION_FACTOR) {
  if (value === null || value === undefined) return value;
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return value;

  const numericFactor = Number(factor);
  if (!Number.isFinite(numericFactor)) return numericValue;

  return numericValue * numericFactor;
}

export function maybeCorrectTuyaKwh(value, controllerType, opts = {}) {
  const { factor = TUYA_ENERGY_CORRECTION_FACTOR, alreadyCorrected = false } = opts;
  if (controllerType !== 'tuya') return value;
  if (alreadyCorrected) return value;
  return correctKwh(value, factor);
}
